import { c as _c } from "react/compiler-runtime";
import { useLoadAccountStatesForConnectedAccount } from "../stores/hooks/useLoadAccountStatesForConnectedAccount";
import { useLoadTermsAcceptanceForConnectedAccount } from "../stores/hooks/useLoadTermsAcceptanceForConnectedAccount";
import { useRehydrateAccount } from "../stores/hooks/useRehydrateAccount";
import { useSyncAccountStoreWithSolanaAccount } from "../stores/hooks/useSyncAccountStoreWithSolanaAccount";
import { useSyncAccountStoreWithWagmiAccount } from "../stores/hooks/useSyncAccountStoreWithWagmiAccount";
import { useSyncAuthStatus } from "../stores/hooks/useSyncAuthStatus";
import { useFixChainArch } from "./use-fix-chain-arch";
export const AccountEffects = t0 => {
  const $ = _c(10);
  const {
    siweAdapter,
    acceptTermsEnabled,
    trackError
  } = t0;
  let t1;
  if ($[0] !== siweAdapter) {
    t1 = {
      siweAdapter
    };
    $[0] = siweAdapter;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useSyncAccountStoreWithSolanaAccount(t1);
  let t2;
  if ($[2] !== siweAdapter) {
    t2 = {
      siweAdapter
    };
    $[2] = siweAdapter;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useSyncAccountStoreWithWagmiAccount(t2);
  useFixChainArch();
  useRehydrateAccount();
  let t3;
  if ($[4] !== siweAdapter || $[5] !== trackError) {
    t3 = {
      siweAdapter,
      trackError
    };
    $[4] = siweAdapter;
    $[5] = trackError;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useSyncAuthStatus(t3);
  let t4;
  if ($[7] !== acceptTermsEnabled || $[8] !== trackError) {
    t4 = {
      acceptTermsEnabled,
      trackError
    };
    $[7] = acceptTermsEnabled;
    $[8] = trackError;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useLoadTermsAcceptanceForConnectedAccount(t4);
  useLoadAccountStatesForConnectedAccount();
  return null;
};